import React, { JSX } from 'react';
import Icons from 'components/atoms/Icons';
import FilterAccordionBtn from '../pld/providers/filters/FilterAccordionBtn';
import StandardFilter from '../pld/shared/filters/StandardFilter';
import {
  AddFilterType,
  FilterPanelType,
  RemoveFilterType,
  SetActiveFilterPanelType,
} from 'components/types/FilterTypes';
import {
  ClinicalTrialsFilterOptionsType,
  ClinicalTrialsFiltersType,
} from 'lib/clinical-trials/types';

type ClinicalTrialsFiltersProps = {
  clearAllFilters: () => void;
  filterPanels: FilterPanelType[];
  setActiveFilterPanel: SetActiveFilterPanelType;
  filters: ClinicalTrialsFilterOptionsType;
  addFilter: AddFilterType;
  removeFilter: RemoveFilterType;
  selectedFacets: Record<string, any[]>;
  selectedFacetsCount: number;
  selectedFilters: ClinicalTrialsFiltersType;
  activeFilterPanel?: string;
  closeMobileControls: () => void;
  resultsCount?: number;
};

const ClinicalTrialsFilters = (
  props: ClinicalTrialsFiltersProps
): JSX.Element => {
  const {
    clearAllFilters,
    filterPanels,
    setActiveFilterPanel,
    filters,
    addFilter,
    removeFilter,
    selectedFacetsCount,
    selectedFilters,
    activeFilterPanel,
    closeMobileControls,
    resultsCount,
  } = props;

  const { cancertypes, phase } = filters;

  return (
    <div className="filter-bar-wrapper clinical-trials-filters">
      <h2 className="screen-recording-only only-desktop" tabIndex={0}>
        Filters
      </h2>
      <div className="filter-bar">
        <div className="filter-title-bar">
          <div
            className="close-button only-mobile"
            onClick={() => closeMobileControls()}
            role="button"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') closeMobileControls();
            }}
          >
            <Icons id="close" className="icon icon-close" aria-hidden="true" />
          </div>
          <h3 className="filters-title only-mobile">Filters</h3>
        </div>
        <div className="filters">
          {filterPanels.map((filterPanel: FilterPanelType) => {
            const menuHeight = filterPanel.active ? { maxHeight: '100%' } : {};

            return (
              <div key={filterPanel.id}>
                <FilterAccordionBtn
                  setActiveFilterPanel={setActiveFilterPanel}
                  filterPanel={filterPanel}
                  activeFilterPanel={activeFilterPanel}
                  selectedFilters={selectedFilters}
                  filters={filters}
                />
                <div>
                  <div className="expanded-filters" style={menuHeight}>
                    {filterPanel.id === 'cancertypes' && filterPanel.active && (
                      <StandardFilter
                        addFilter={addFilter}
                        filters={cancertypes}
                        filterCategory="cancertypes"
                        placeholder="Enter cancer type"
                        removeFilter={removeFilter}
                        selectedData={selectedFilters.cancertypes}
                        title="Types of Cancer"
                        noCount
                      />
                    )}
                    {filterPanel.id === 'phase' && filterPanel.active && (
                      <StandardFilter
                        addFilter={addFilter}
                        filters={phase}
                        filterCategory="phase"
                        placeholder="Enter phase"
                        removeFilter={removeFilter}
                        selectedData={selectedFilters.phase}
                        title="Phase"
                        noCount
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="bg-primary btns-container">
          {selectedFacetsCount ? (
            <button
              className="btn-secondary no-icon only-mobile"
              onClick={() => clearAllFilters()}
              aria-label="Clear All Filters"
            >
              Clear All
            </button>
          ) : null}
          <button
            className="view-all-btn btn-primary no-icon btn-fw only-mobile"
            onClick={() => closeMobileControls()}
          >
            Show {resultsCount ?? 0} Results
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClinicalTrialsFilters;
